export const WAITLIST = {
	page: 'waitlist-page',
	headline: 'waitlist-headline',
	form: 'waitlist-form',
	nameInput: 'waitlist-name-input',
	emailInput: 'waitlist-email-input',
	countryCodeSelect: 'waitlist-country-code-select',
	whatsappInput: 'waitlist-whatsapp-input',
	consentCheckbox: 'waitlist-consent-checkbox',
	submitButton: 'waitlist-submit-button',
	formError: 'waitlist-form-error',
	success: 'waitlist-success',
	successName: 'waitlist-success-name',
	adminLink: 'waitlist-admin-link',
	heroImage: 'waitlist-hero-image',
};

export const ADMIN = {
	loginPage: 'admin-login-page',
	dashboard: 'admin-dashboard',
	totalCount: 'admin-total-count',
	weekCount: 'admin-week-count',
	searchInput: 'admin-search-input',
	exportButton: 'admin-export-button',
	logoutButton: 'admin-logout-button',
	table: 'admin-signups-table',
	emptyState: 'admin-empty-state',
	row: 'admin-signup-row',
	deleteButton: 'admin-delete-button',
	confirmDelete: 'admin-confirm-delete-button',
	cancelDelete: 'admin-cancel-delete-button',
	loginError: 'admin-login-error',
};
